import styled, { css, StyledComponent, FlattenSimpleInterpolation } from 'styled-components'
import { StickyStatus, Offset } from './types'
import * as supports from '@owl-nest/feature-detection'

type StickyContextConfig = {
  sticky?: (status: StickyStatus) => FlattenSimpleInterpolation
  fallbackToSticky?: boolean
}

type StickyContextProps = {
  $status: StickyStatus
  $offset?: Offset
}

export function stickyContext(
  StickyComponent: StyledComponent<any, any, any, any>,
  { sticky, fallbackToSticky = false }: StickyContextConfig,
): StyledComponent<'div', any, StickyContextProps, never> {
  return styled.div<StickyContextProps>`
    position: relative;

    ${StickyComponent} {
      ${({ $status, $offset = { top: 0 } }) => {
        if (supports.positionSticky() && fallbackToSticky) {
          return css`
            position: sticky;
            top: ${$offset.top}px;
            bottom: ${$offset.bottom}px;
            background-color: #fff;
          `
        }
        return sticky && sticky($status)
      }}
    }
  `
}
